import type { StoreId, WebhookEndpointId } from "@KassaroAB/shared/types/ids";
import type {
  RestCreateWebhookEndpoint,
  RestUpdateWebhookEndpoint,
  RestWebhookEndpoint,
  RestWebhookEndpointWithSecret,
  RestWebhookTestResult,
} from "@KassaroAB/shared/types/webhookEndpoint";
import { api } from "../utils/api";

const endpointsPath = (storeId: StoreId) =>
  `stores/${storeId}/webhookEndpoints`;

export const getWebhookEndpointsApi = async (
  storeId: StoreId,
): Promise<RestWebhookEndpoint[]> => api.get(endpointsPath(storeId));

export const createWebhookEndpointApi = async (
  storeId: StoreId,
  data: RestCreateWebhookEndpoint,
): Promise<RestWebhookEndpointWithSecret> =>
  api.post(endpointsPath(storeId), data);

export const updateWebhookEndpointApi = async (
  storeId: StoreId,
  endpointId: WebhookEndpointId,
  data: RestUpdateWebhookEndpoint,
): Promise<RestWebhookEndpoint> =>
  api.patch(`${endpointsPath(storeId)}/${endpointId}`, data);

export const deleteWebhookEndpointApi = async (
  storeId: StoreId,
  endpointId: WebhookEndpointId,
): Promise<void> => api.delete(`${endpointsPath(storeId)}/${endpointId}`);

export const rotateWebhookSecretApi = async (
  storeId: StoreId,
  endpointId: WebhookEndpointId,
): Promise<RestWebhookEndpointWithSecret> =>
  api.post(`${endpointsPath(storeId)}/${endpointId}/rotateSecret`, {});

export const sendWebhookTestApi = async (
  storeId: StoreId,
  endpointId: WebhookEndpointId,
): Promise<RestWebhookTestResult> =>
  api.post(`${endpointsPath(storeId)}/${endpointId}/test`, {});
